import { compose, pure } from 'recompose';
import HrTableFilters from './hrTableFilters';

const enhance = compose(
  pure,
);
export default enhance(HrTableFilters);
